import { ALO_API_HOST } from 'src/scripts/utils/constants';
import { GeocodeParams, LatLng, LatLngError } from './storeLocatorTypes';

export const getGeocode = async (params: GeocodeParams): Promise<LatLng | LatLngError> => {
  const url = new URL(`${ALO_API_HOST}/v1/geocode`);

  url.searchParams.append('postal_code', params.postal_code);
  url.searchParams.append('country_code', params.country_code);

  const response = await fetch(url.toString());

  if (!response.ok) {
    const status = response.status;
    console.error('Error fetching geocode:', status);
    const error = await response.json();
    error.status = status;
    return { error };
  }

  const data: LatLng = await response.json();
  return data;
};
